import { render, staticRenderFns } from "./MailboxMailBarMail.vue?vue&type=template&id=3b6ac048&scoped=true"
import script from "./MailboxMailBarMail.vue?vue&type=script&lang=js"
export * from "./MailboxMailBarMail.vue?vue&type=script&lang=js"
import style0 from "./MailboxMailBarMail.vue?vue&type=style&index=0&id=3b6ac048&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6ac048",
  null
  
)

export default component.exports